module.exports = __webpack_public_path__ + "img/lopata.8297d837.jpg";